"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION_ERROR = void 0;
// Error
exports.ACTION_ERROR = 'request_error';
//# sourceMappingURL=mobileCommunicator.constants.js.map